export const PRODUCT_BLOCKER_UNFINISHED_AUCTION = 'usedInUnfinishedAuction';
export const PRODUCT_BLOCKER_AUCTION_LIMIT = 'auctionLimitDefined';
export const PRODUCT_BLOCKER_USED_IN_AUCTION = 'usedInAuction';

export const transformProductDeactivationBlockers = (t, blockerKey) => {
    let result;
    switch (blockerKey) {
        case PRODUCT_BLOCKER_UNFINISHED_AUCTION:
            result = t('products.blocker.deactivation.unfinished-auction');
            break;
        case PRODUCT_BLOCKER_AUCTION_LIMIT:
            result = t('products.blocker.deactivation.auction-limit-defined');
            break;
        default:
            throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};

export const transformProductModificationBlockers = (t, blockerKey) => {
    let result;
    switch (blockerKey) {
        case PRODUCT_BLOCKER_UNFINISHED_AUCTION:
            result = t('products.blocker.modification.unfinished-auction');
            break;
        case PRODUCT_BLOCKER_USED_IN_AUCTION:
            result = t('products.blocker.modification.used-in-auction');
            break;
        default:
            throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};
